import { render } from "./Footer.vue?vue&type=template&id=af385a0c&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=af385a0c&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af385a0c"]])

export default __exports__